import { AccountRole } from './account';

export enum PaymentStatusFilter {
  All = 'ALL',
  Yes = 'YES',
  No = 'NO',
}

export interface AccountsFilters {
  searchBy?: string;
  readableId?: string;
  appVersion?: string;
  payment?: string | boolean | PaymentStatusFilter;
  role?: string | AccountRole;
  startCreatedDate?: string;
  endCreatedDate?: string;
}
